import React from 'react'

import { trackedClick, getMarkedCookieValue } from '../../utils'
import TryErrorForProduction from './TryErrorForProduction'
import TryErrorForSandbox from './TryErrorForSandbox'

class SignUp extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            url: global.INTENTO_CONSOLE_URL || process.env.INTENTO_CONSOLE_URL,
            currentUrl: window.location,
        }
    }

    render() {
        const { url, currentUrl } = this.state
        const { provider = { name: 'any provider' } } = this.props
        const href = `${url}?next=${currentUrl}#mt-demo`

        return (
            <a
                className="button button--sm button--gray button--outline button--inline"
                href={href}
                onClick={trackedClick('Sign up link clicked', {
                    source: 'Intent Demo, Try Error',
                    title: provider.name,
                })}
            >
                sign up
            </a>
        )
    }
}

class TryError extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            production: getMarkedCookieValue('IPK'),
            token: getMarkedCookieValue('UAT'),
        }
    }

    render() {
        const { production, token } = this.state
        const { error, provider = { name: 'any provider' } } = this.props

        if (production) {
            return <TryErrorForProduction error={error} provider={provider} />
        }

        if (token && !production) {
            return <TryErrorForSandbox error={error} provider={provider} />
        }

        if (!provider.integrated) {
            // alibaba
            // youdao
            return (
                <div className="try-intento__input-control">
                    This provider is not generally available via Intento yet.
                    More information is available at the Developer Console.
                    <br />
                    Please <SignUp provider={provider} /> and obtain the
                    production access.
                </div>
            )
        }

        if (!provider.billable && !provider.custom_model) {
            // tencent
            return (
                <div className="try-intento__input-control">
                    This provider is not generally available via Intento yet.
                    More information is available at the Developer Console.
                    <br />
                    Please <SignUp provider={provider} /> and obtain the
                    production access.
                </div>
            )
        }

        if (!provider.billable && provider.custom_model) {
            return (
                <div className="try-intento__input-control">
                    To use this provider, let us access your model as described
                    in the Developer Console.
                    <br />
                    Please <SignUp provider={provider} /> and obtain the
                    production access.
                </div>
            )
        }

        // below: some error for an integrated, billable provider

        if (!provider.stock_model && provider.custom_model) {
            // google auto_ml
            return (
                <div className="try-intento__input-control">
                    To use this provider, let us access your model as described
                    in the Developer Console.
                    <br />
                    Please <SignUp provider={provider} /> and obtain the
                    production access.
                </div>
            )
        }

        if (provider.own_auth) {
            return (
                <div className="try-intento__input-control">
                    This provider is not generally available via Intento yet.
                    More information is available at the Developer Console.
                    <br />
                    Please <SignUp provider={provider} /> and obtain the
                    production access.
                </div>
            )
        }

        return (
            <div className="try-intento__input-control try-intento__error">
                ({error.code}) {error.message}
            </div>
        )
    }
}

export default TryError



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/TryError/index.jsx